import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = { class: "modal-container show" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "blocker" }, null, -1)
const _hoisted_3 = {
  class: "modal",
  style: {"width":"800px"}
}
const _hoisted_4 = { class: "modal__header modal__header--success" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h3", { class: "clipboard__header--title" }, "Wordpress Plugin Pixel Activation", -1)
const _hoisted_6 = { class: "modal__content" }
const _hoisted_7 = { class: "clipboard--help__desk pa--top-1 pa--bottom-2" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "clipboard--help__desk--count" }, "1", -1)
const _hoisted_9 = { class: "clipboard--help__desk--content" }
const _hoisted_10 = { class: "clipboard--help__desk--content__text" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = { style: {"font-size":"80%"} }
const _hoisted_13 = ["href", "download"]
const _hoisted_14 = { class: "pa--left-0" }
const _hoisted_15 = {
  key: 0,
  class: "clipboard--help__desk pa--y-2 align--baseline"
}
const _hoisted_16 = { class: "form-field form-field__outline ma--x-1" }
const _hoisted_17 = { class: "form-field__outline--control" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", {
  for: "site-url",
  class: "form-field__outline--control__label"
}, "Email", -1)
const _hoisted_19 = ["disabled"]
const _hoisted_20 = {
  key: 1,
  class: "clipboard--help__desk pa--y-2 align--baseline"
}
const _hoisted_21 = { class: "form-field form-field__outline ma--x-1" }
const _hoisted_22 = { class: "form-field__outline--control" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", {
  for: "site-url",
  class: "form-field__outline--control__label"
}, "Site Name", -1)
const _hoisted_24 = ["disabled"]
const _hoisted_25 = {
  key: 2,
  class: "clipboard--help__desk pa--y-2 align--baseline"
}
const _hoisted_26 = { class: "form-field form-field__outline ma--x-1" }
const _hoisted_27 = { class: "form-field__outline--control" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", {
  for: "site-url",
  class: "form-field__outline--control__label"
}, "Site Auth Code", -1)
const _hoisted_29 = ["disabled"]
const _hoisted_30 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_31 = {
  key: 0,
  class: "color--primary-green text--weight-bold text--align-center"
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "clipboard--help__desk pa--y-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "clipboard--help__desk--count" }, "2"),
  /*#__PURE__*/_createElementVNode("div", { class: "clipboard--help__desk--content__text" }, " Once the settings are applied correctly, you'll receive a confirmation email and site will be activated ")
], -1)
const _hoisted_33 = { class: "clipboard--help__desk pa--y-2 align--baseline" }
const _hoisted_34 = { class: "form-field form-field__outline ma--x-1" }
const _hoisted_35 = { class: "form-field__outline--control" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", {
  for: "site-url",
  class: "form-field__outline--control__label"
}, "Email", -1)
const _hoisted_37 = ["disabled"]
const _hoisted_38 = { class: "clipboard--help__desk pa--y-2" }
const _hoisted_39 = { class: "form-checkbox" }
const _hoisted_40 = { for: "termsAndConditions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_outline = _resolveDirective("outline")!
  const _directive_clipboard = _resolveDirective("clipboard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("a", {
          class: "fa fa-times clipboard__header--clear",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clearPixel && _ctx.clearPixel(...args)))
        })
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createTextVNode(" Copy the information and paste it in your wordpress plugin settings page for site " + _toDisplayString(_ctx.pixelActivationItem.siteUrl) + " only: ", 1),
              _hoisted_11,
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("a", {
                  href: _ctx.pluginZipUrl,
                  download: _ctx.appWordpressPluginZip
                }, "Download WordPress Plugin", 8, _hoisted_13)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          (_ctx.termsAndConditions)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createTextVNode(" Email - "),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-field__outline--control__input",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.email) = $event)),
                      style: {"width":"400px"}
                    }, null, 512), [
                      [_vModelText, _ctx.email],
                      [_directive_outline]
                    ]),
                    _hoisted_18
                  ])
                ]),
                _withDirectives((_openBlock(), _createElementBlock("button", {
                  class: "btn btn--primary",
                  disabled: !_ctx.termsAndConditions
                }, [
                  _createTextVNode(" Copy ")
                ], 8, _hoisted_19)), [
                  [_directive_clipboard, _ctx.email, "copy"],
                  [_directive_clipboard, _ctx.copyClipboard, "success"]
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.termsAndConditions)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                _createTextVNode(" Site Name - "),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-field__outline--control__input",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.siteName) = $event)),
                      style: {"width":"400px"}
                    }, null, 512), [
                      [_vModelText, _ctx.siteName],
                      [_directive_outline]
                    ]),
                    _hoisted_23
                  ])
                ]),
                _withDirectives((_openBlock(), _createElementBlock("button", {
                  class: "btn btn--primary",
                  disabled: !_ctx.termsAndConditions
                }, [
                  _createTextVNode(" Copy ")
                ], 8, _hoisted_24)), [
                  [_directive_clipboard, _ctx.siteName, "copy"],
                  [_directive_clipboard, _ctx.copyClipboard, "success"]
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.termsAndConditions)
            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                _createTextVNode(" Site Authorization Code - "),
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-field__outline--control__input",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.siteAuthCode) = $event)),
                      style: {"width":"400px"}
                    }, null, 512), [
                      [_vModelText, _ctx.siteAuthCode],
                      [_directive_outline]
                    ]),
                    _hoisted_28
                  ])
                ]),
                _withDirectives((_openBlock(), _createElementBlock("button", {
                  class: "btn btn--primary",
                  disabled: !_ctx.termsAndConditions
                }, [
                  _createTextVNode(" Copy ")
                ], 8, _hoisted_29)), [
                  [_directive_clipboard, _ctx.siteAuthCode, "copy"],
                  [_directive_clipboard, _ctx.copyClipboard, "success"]
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _hoisted_30,
        (_ctx.userAlert)
          ? (_openBlock(), _createElementBlock("div", _hoisted_31, _toDisplayString(_ctx.userMessage), 1))
          : _createCommentVNode("", true),
        _hoisted_32,
        _createElementVNode("div", _hoisted_33, [
          _createTextVNode(" Email to developer - "),
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-field__outline--control__input",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.request.email) = $event)),
                style: {"width":"400px"}
              }, null, 512), [
                [_vModelText, _ctx.request.email],
                [_directive_outline]
              ]),
              _hoisted_36
            ])
          ]),
          _createElementVNode("button", {
            class: "btn btn--primary",
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.sendMail && _ctx.sendMail(...args))),
            disabled: !_ctx.termsAndConditions
          }, " Send ", 8, _hoisted_37)
        ]),
        _createElementVNode("div", _hoisted_38, [
          _createElementVNode("div", _hoisted_39, [
            _withDirectives(_createElementVNode("input", {
              id: "termsAndConditions",
              type: "checkbox",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.termsAndConditions) = $event))
            }, null, 512), [
              [_vModelCheckbox, _ctx.termsAndConditions]
            ]),
            _createElementVNode("label", _hoisted_40, "I hereby agree to all Terms and Conditions associated with using the " + _toDisplayString(_ctx.appName) + " Dashboard.", 1)
          ])
        ])
      ])
    ])
  ]))
}